export default "__VITE_ASSET__4HHbrIxq__"